import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import { RecurringZoomMeetingFormDataVM, emailPostfix } from './recurring-zoom-meeting-form-data.viewmodel';
import { InfoPopover } from '../../../../../../global/info-popover/info-popover';

interface IProps {
    formRecurringMeetingData: RecurringZoomMeetingFormDataVM;
}

const zoomGroupMeetingsInfoMessage = <FormattedMessage
    id='oe.zoomWebinar.zoomGroupMeetingsInfoMessage'
    description='Info message'
    defaultMessage='The Zoom User will be added to the selected Group, and all Zoom Meeting Settings will be inherited from the Group.'
/>;

const RecurringZoomForm = mobxReact.observer((props: IProps) => {
    const { formRecurringMeetingData } = props;

    return (<div className='m-bottom-25px'>
        <FormField label={
            <FormattedMessage id='oe.input.meetingTopic' description='Input label' defaultMessage='Meeting Topic' />
        }>
            <input
                className='oe-form-field__control'
                value={formRecurringMeetingData.getMeetingTopic()}
                onChange={e => formRecurringMeetingData.setMeetingTopic(e.target.value)}
                onBlur={() => formRecurringMeetingData.checkMeetingTopic()}
            />
            {formRecurringMeetingData.getFieldError('topic') &&
                <span className='oe-form-field__error'>{formRecurringMeetingData.getFieldError('topic')}</span>}
        </FormField>
        <FormField label={
            <FormattedMessage id='oe.zoomWebinar.zoomUserEmail' description='Input label' defaultMessage='Zoom User Email' />
        }>
            <div className='flex center'>
                <div className='zoom-email-field'>
                    <input
                        className='oe-form-field__control'
                        value={formRecurringMeetingData.getEmail()}
                        onChange={e => { formRecurringMeetingData.setEmail(e.target.value); }}
                        onBlur={() => { formRecurringMeetingData.checkEmail(); }}
                    />
                </div>
                <div className='zoom-email-field'>
                    <label className='oe-form-field__title zoom-email'>
                        <span>{emailPostfix}</span>
                    </label>
                </div>
            </div>
            {formRecurringMeetingData.getFieldError('email') &&
                <span className='oe-form-field__error'>{formRecurringMeetingData.getFieldError('email')}</span>}
        </FormField>
        <FormField label={
            <FormattedMessage id='oe.zoomWebinar.zoomUserName' description='Input label' defaultMessage='Zoom User Name' />
        }>
            <input
                className='oe-form-field__control'
                value={formRecurringMeetingData.getUserName()}
                onChange={e => { formRecurringMeetingData.setUserName(e.target.value); }}
                onBlur={() => { formRecurringMeetingData.checkUserName(); }}
            />
            {formRecurringMeetingData.getFieldError('username') &&
                <span className='oe-form-field__error'>{formRecurringMeetingData.getFieldError('username')}</span>}
        </FormField>

        <FormField label={
            <div className='flex m-bottom-6px'>
                <FormattedMessage id='oe.input.selectGroupForMeetingSettings' description='Input label' defaultMessage='Select Group for Meeting Settings' />
                <InfoPopover className='m-left-8px'>
                    {zoomGroupMeetingsInfoMessage}
                </InfoPopover>
            </div>
        }>
            <select
                className='oe-form-field__control'
                value={formRecurringMeetingData.getGroup()}
                onChange={e => formRecurringMeetingData.setGroup(Number(e.target.value))}
            >
                {
                    formRecurringMeetingData.allowedZoomGroups
                        .map(({ name, zoomGroupId }, i) => {
                            return <option value={zoomGroupId} key={i}>{name}</option>;
                    })
                }
            </select>
        </FormField>
    </div>);
});

export { RecurringZoomForm };